import { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { TRANSLATIONS as translation } from "../../../../../../utils/constant.utils";
import TableWithExtractSearchLayout from "../../../../../common/Layout/table-with-extract-search/table-with-extract-search.layout";
import { TablePagination } from "../../../../../common/details-table/table-pagination.component";
import { TABLE_PAGINATION_KEY, MODAL_CUSTOM_MESSAGE } from "../../../../../../constants/external-constants";
import { NoSubscription } from "../../../../dashboard/no-subscription/no-subscription.component";
import { configOutputRecordActions } from "../../../../../../store/external/recharge-reducer/output-configuration-reducer/output-configuration-output-records.reducer";
import ModalContainer from "../../../../../common/modal/modal-container/modal-container.component";
import OutputRecordsInfo from "../../../output-records/modal/output-records-info.component";
import { OutputRecordAction } from "../../../../../../store/external/recharge-reducer/output-record.reducer/output-record.reducer";

class OutputRecord extends Component {
    constructor(props) {
        super(props);
        this.displaySearchBox = this.displaySearchBox.bind(this)
        this.state = {
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
            displaySearch: false,
            modalTitle:"",
            showModalForm:false,
            modalIsLoading:false,
            selectedRecordData:{}
        };
    }

    componentDidMount() {
        const { outputConfigurationId } = this.props
        this.props.getOutputConfigOutputRecords(outputConfigurationId);
    }

    componentWillUnmount() {
        this.props.setDefaultConfigOutputRecords();
    }

    displaySearchBox = () => {
        this.setState({ displaySearch: !this.state.displaySearch })
    };

    resizePage = (value) => {
        const { getOutputConfigOutputRecords, resizeConfigOutputRecordPage, outputConfigurationId } = this.props;
        resizeConfigOutputRecordPage(value);
        getOutputConfigOutputRecords(outputConfigurationId);
    };

    onClickExtract = (e) => {
        const { outputConfigurationId } = this.props
        if (window.confirm(this.state.exportAlertMsg)) {
            this.props.extractConfigOutputRecords(outputConfigurationId);
        }
    };

    loading = () => {
        return (
            <NoSubscription />
        );
    };

    onColumnSortConfigOutputRecord = (columnClicked, isSortedAsc) => {
        const { outputConfigurationId, sortConfigOutputRecordItems } = this.props;
        sortConfigOutputRecordItems(columnClicked, isSortedAsc, outputConfigurationId);
    }

    paginationAction = (index) => {
        const { outputConfigurationId, getOutputConfigOutputRecords } = this.props;
        getOutputConfigOutputRecords(outputConfigurationId, index);
    }

    handleRowClick = async (isNew, item, hasLink) =>{
        const { RechargingOutputRecordID } = item;
        const { fetchOutputRecordById, fetchAttachment } = this.props;
        if(hasLink) {
             this.setState({
                modalIsLoading: true,
                showModalForm: true, 
                modalTitle: `Output Record \u00A0\u00A0 Loading...`,
            })
            var data = await fetchOutputRecordById(RechargingOutputRecordID);
            var fetchedFiles = await fetchAttachment(RechargingOutputRecordID);
            const generatedFiles = fetchedFiles ? fetchedFiles.map(file => ({ 
                key: file.Key,
                name: file.FileName,
                filePath: file.FilePath
            })) : [];

            const recordDataWithFiles = {
                ...data,
                GeneratedFiles: generatedFiles
            };
            this.setState({
                modalIsLoading: false,
                modalTitle: `Output Record \u00A0\u00A0 ${data.OutputRecordStatus.toUpperCase()}`,
                selectedRecordData: recordDataWithFiles,
            })

            return
        }
    }

    
     handleCloseFormModal = () => {
        this.setState({ showModalForm: false})
    }
    
    render() {
        const { configOutputRecords, setConfigOutputRecordColSearchStr, getOutputConfigOutputRecords, outputConfigurationId } = this.props;
        const { modalTitle, showModalForm, modalIsLoading, selectedRecordData } = this.state;
        return (
            <TableWithExtractSearchLayout
                displaySearchBox={this.displaySearchBox}
                extractAction={this.onClickExtract}

                //Access Type
                isReadOnly={false}
                isReadAndExtractOnly={false}
                isReadAndWrite={true} 
                hideCustomColumn={true}
            >
                <>

                    <ModalContainer
                            title={modalTitle}
                            show={showModalForm}
                            handleModal={this.handleCloseFormModal}
                            hideBtn={true}                                        
                            customClass=""
                            noTranslation                                        
                        >

                            <div>
                                <OutputRecordsInfo 
                                    isLoading={modalIsLoading}
                                    recordData={selectedRecordData}
                                />
                            </div>

                    </ModalContainer>

                    {
                        configOutputRecords.isConfigOutputRecordLoaded ?
                            <TablePagination
                                key={TABLE_PAGINATION_KEY.outputRecord}
                                classNameWrapper="overflow-auto"
                                columns={configOutputRecords.configOutputRecordItems.Headers}
                                pageList={configOutputRecords.configOutputRecordItems.Data}
                                pages={configOutputRecords.configOutputRecordItems.Pagination}
                                paginationAction={this.paginationAction}
                                onColumnClick={this.onColumnSortConfigOutputRecord}
                                onColumnSearch={() => getOutputConfigOutputRecords(outputConfigurationId)}
                                onColumnSearchChange={setConfigOutputRecordColSearchStr}
                                rowClickAction={(item, hasLink) => { this.handleRowClick(false, item, hasLink) }}
                                isColSearchShow={this.state.displaySearch}
                                resizePage={this.resizePage}
                                totalPage={configOutputRecords.configOutputRecordItems.Pagination.TotalEntries}
                                tablePaginationKey={TABLE_PAGINATION_KEY.outputRecord}
                                hidePageSizeSelection={configOutputRecords.configOutputRecordItems.Pagination.TotalEntries === 0}
                            />
                        : this.loading()
                    }
                </>
            </TableWithExtractSearchLayout>
        );
    }
}


export default withRouter(connect(
    state => {
        const { configOutputRecords, outputRecord, attachFile } = state;
        return { configOutputRecords, 
                 translation,
                 outputRecord,
                 attachFile                
                };
    },
    dispatch => bindActionCreators(
        Object.assign({}, configOutputRecordActions, OutputRecordAction),
        dispatch
    )
)(OutputRecord));